import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { FavoriteCardOperationProps } from './type'

import { ContentCopyFilledIcon } from '@/components/icons/ContentCopyFilled'
import { DeleteFilledIcon } from '@/components/icons/DeleteFilled'
import { EditFilledIcon } from '@/components/icons/EditFilled'
import { Icon } from '@/components/ui'

import { FavoriteCardOperationListItem } from './FavoriteCardOperationListItem'

export const FavoriteCardOperation = ({
  isEditableByMe,
  isDepositStore,
  canDuplicateByMe,
  onClickCopy,
  onClickDelete,
  onClickEdit,
}: FavoriteCardOperationProps) => {
  const { t } = useTranslation()

  return (
    <ul
      className={clsx(
        'tw-overflow-hidden tw-rounded',
        'tw-divide-y tw-divide-gray-300'
      )}
    >
      {canDuplicateByMe && (
        <FavoriteCardOperationListItem
          icon={
            <Icon icon={ContentCopyFilledIcon} size={'xl'} color={'primary'} />
          }
          text={t('favorite.list.duplicate')}
          onClick={onClickCopy}
        />
      )}
      {isEditableByMe && (
        <>
          <FavoriteCardOperationListItem
            icon={
              <Icon icon={DeleteFilledIcon} size={'xl'} color={'primary'} />
            }
            text={t('favorite.list.delete')}
            onClick={onClickDelete}
          />
          <FavoriteCardOperationListItem
            icon={<Icon icon={EditFilledIcon} size={'xl'} color={'primary'} />}
            text={
              isDepositStore
                ? t('favorite.list.title_edit_share')
                : t('favorite.list.title_edit')
            }
            onClick={onClickEdit}
          />
        </>
      )}
    </ul>
  )
}
